import API from '@/api/index';

const notification = {
  actions: {
    getDailyReporting ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.reporting.getDailyReporting(data).then(response => {
          let result = response.data;
          if (!result.code && result.data) {
            resolve(result.data);
          } else {
            reject(result);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },
  }
};

export default notification;


// WEBPACK FOOTER //
// ./src/store/modules/reporting.js